import { useGetAccessCatalogQuery } from "features/accessGroups/accessGroupsApi";
import type { UserPlatformProfile } from "types/interfaces/user";
import AccessGroupPermissionsPanel from "./AccessGroupPermissionsPanel";
import ClientAccessPanel from "./ClientAccessPanel";

interface Props {
  profile: Partial<UserPlatformProfile> | null | undefined;
}

const TITLE = "Your access & permissions";

/** What a user may open, page by page, on an account page: an internal user's
 * access group, or a client user's own switches. */
export default function OwnAccessPanel({ profile }: Props) {
  const isClient = profile?.user_type === "client";
  const group = profile?.access?.group;
  const { data: catalog } = useGetAccessCatalogQuery(undefined, {
    skip: !profile,
  });
  if (!profile || !catalog) return null;
  if (isClient) {
    return (
      <ClientAccessPanel
        catalog={catalog}
        state={profile}
        title={TITLE}
        subHeader="What you can open on the web platform. Your Calibrate team sets it."
      />
    );
  }
  // Without a group an employee still opens the pages open to every user.
  return (
    <AccessGroupPermissionsPanel
      catalog={catalog}
      tiers={group?.tiers ?? {}}
      title={TITLE}
      subHeader={
        group
          ? `Access group: ${group.name}. It decides what you see and do on the web platform.`
          : "No access group yet. Ask a Super Admin to assign one."
      }
      appliesTo={group?.applies_to}
      aiAgent={profile.is_ai_agent_user === true}
    />
  );
}
